<template>
    <div>
        <div class="form-wrap">
            <div style="padding: 10px" v-if="!is_dengbao" >
                <p class="fr link" v-rblink.replace="{name:'loginByUsername'}">账号密码登录</p>
            </div>
            <div class="logo1">

            </div>
            <div class="h2">手机号登录</div>
            <van-cell-group>
                <van-field
                        v-model="formData.phone"
                        type="number"
                        placeholder="请输入手机号"
                />
                <van-field
                        v-model="formData.code"
                        center
                        type="number"
                        maxlength="4"
                        clearable
                        placeholder="请输入短信验证码"
                >
                    <van-button slot="button" size="small" @click="getCode" :disabled="clockSecond>0" round type="danger">{{clockSecond>0? clockSecond+'s获取验证码':'获取验证码'}}</van-button>
                </van-field>
            </van-cell-group>
            <div style="padding: 20px;">
                <van-button type="danger" round size="large"  @click.stop="save">登录</van-button>
            </div>
            <div class="tip">未注册手机验证后自动登录</div>
            <!--<div class="sanfang-login">
                <div class="title">
                    第三方账号登录
                </div>
                <div class="ul flex-wrap" >
                    <div @click="notice" class="weixin flex-item-1">

                    </div>
                    <div @click="notice" class="alipay flex-item-1">

                    </div>
                    <div @click="notice" class="weibo flex-item-1">

                    </div>
                </div>
            </div>-->
            <div class="tip">
                    <!-- 登录即表示同意<span class="link"  v-rblink="{name:'cmsDetail',query:{id:8}}">《啦啦操GO使用协议》</span> -->
            </div>
            <div class="cert-status login-success" :style="{top:success?'0px':'100%'}">
                <div class="cert-status-content">
                    <div class="cert-status-icon-success"></div>
                    <p class="cert-status-title">{{phone}}</p>
                    <p class="cert-status-title">登陆成功</p>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped="">
    .form-wrap{ padding: 0 50px}
    .logo1{
        width: 85px; height: 85px;
        margin: 60px auto 20px auto;
        background: url(../../assets/images/icon-logo.png) no-repeat;
        background-size: 100%;
    }
    .sanfang-login{ margin: 30px 0 0 0 }
    .sanfang-login .title{ font-size: 12px; color: #999; text-align: center}
    .sanfang-login .ul{  justify-content:   space-between  ;    width: 150px;
        margin: 20px auto; }
    .sanfang-login .ul div{ flex: 0 0 50px; width: 30px; height: 30px ; }
    .sanfang-login .ul div.weixin{
        background: url(../../assets/images/icon-weixin.png) no-repeat;
        background-size: 100%;
    }
    .sanfang-login .ul div.alipay{
        background: url(../../assets/images/icon-alipay.png) no-repeat;
        background-size: 100%;
    }
    .sanfang-login .ul div.weibo{
        background: url(../../assets/images/icon-weibo.png) no-repeat;
        background-size: 100%;
    }
    .tip{font-size: 12px; color: #999 ; text-align: center}
    .h2{
        font-size: 16px;
        font-weight: bold;
        padding: 15px;}

</style>
<script>
    import {
        Cell, CellGroup,NoticeBar,Field,Button,Toast
    } from 'vant';
    export default {
        name: 'loginBySms',
        components: {
            [Cell.name]: Cell,
            [CellGroup.name]: CellGroup,
            [Field.name]: Field,
            [NoticeBar.name]: NoticeBar,
            [Button.name]: Button,
        },
        data: function () {
            return {
                clockSecond:0,
                formData:{
                    phone:'',
                    code:'',
                },
                phone:'',
                is_dengbao:true,
                success: false,
            }
        },
        mounted: function () {
            document.title = "用户登录";
            this.fetch();
        },
        methods: {
            fetch(){
                let that = this;
                that.$api.get('/api/index/logindetail', { 
                }, (res) => { 
                    that.is_dengbao = res.data.is_dengbao;
                }, (res) => {
                    // Toast.fail(res.msg);
                })
            },
            getCode(){
                //获取验证码
                var that = this;
                this.$api.post("/api/index/phonecode", {
                    'phone' :that.formData.phone
                }, r => {
                    that.clockSecond = 60;
                var t = setInterval(function () {
                    if(that.clockSecond>0){
                        that.clockSecond--;
                    }else{
                        clearInterval(t);
                    }
                },1000)
            });
            },
            save(){
                var that = this;
                this.$api.get("/api/index/loginbysms", that.formData, r => {
                    Toast('成功');
                    localStorage.setItem('_pspt',r.data.token);
                    localStorage.setItem('_token',r.data.token);
                    that.phone =  r.data.phone.substring(0,3)+'****'+r.data.phone.substring(7) ;
                    that.success = true;
                    appEvent({
                        name: 'login',
                        query: {
                            token:r.data.token,
                            phone:r.data.phone,
                        }
                    });
                    setTimeout(function(){
                            rbLink({
                                'name':'Index'
                            },'back');
                        },1000);
                        return 
                    if(r.data.idCheck == false){
                        setTimeout(function(){
                            rbLink({
                                'name':'profileTodo'
                            },'replace');
                        },1000);
                    }else{
                        setTimeout(function(){
                            rbLink({
                                'name':''
                            },'back');
                        },1000);
                    }
                });
            },
            notice(){
                Toast('即将开通,敬请期待');
            }
        }
    }
</script>


// WEBPACK FOOTER //
// loginBySms.vue?0ef25b7a